<app-page>
  <app-page-title [title]="'SIDENAV.REGISTRATION-LINKS' | translate">
    <dx-button
      class="cta-btn"
      type="normal"
      icon="add"
      [text]="'REGISTRATION-LINKS.NEW-REGISTRATION-LINK' | translate"
      (click)="navigateToNewRegistrationLink()"
    ></dx-button>
  </app-page-title>
  <app-table
    [data]="allRegistrationLinks || []"
    [columns]="columns"
    [showSearch]="true"
    [searchLabel]="'COMMON.SEARCH' | translate"
    [searchPlacehoder]="'COMMON.SEARCH' | translate"
    (onRowClick)="navigateToRegistrationLink($event)"
    [stateKey]="stateKey"
    [showFilterPanel]="true"
  ></app-table>
</app-page>